import { Stack, Box, useMediaQuery, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormField from './FormField';
import QuestionLabel from './QuestionLabel';
import { fieldSx } from './formTheme';
import { useTranslation } from 'react-i18next';

export default function AccommodationForm() {
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const dietSelection = watch('accommodationPreferences.diet');

  const fields = [
    {
      type: 'select',
      label: t('diet'),
      name: 'accommodationPreferences.diet',
      options: [
        { label: t('omnivore'), value: 'Wszystkożerca' },
        { label: t('vegetarian'), value: 'Wegetarianin' },
        { label: t('vegan'), value: 'Weganin' },
        { label: t('other'), value: 'Inne' },
      ],
    },
    {
      type: 'radio',
      label: t('dairy_products'),
      name: 'accommodationPreferences.dairyProducts',
      options: [
        { label: t('yes'), value: 'TAK' },
        { label: t('no'), value: 'NIE' },
      ],
    },
    {
      type: 'textarea',
      label: t('accommodation_preferences'),
      name: 'accommodationPreferences.accommodationPreferences',
      alternateLabel: true,
    },
    {
      type: 'textarea',
      label: t('health_safety_info'),
      name: 'accommodationPreferences.healthSafetyInfo',
      alternateLabel: true,
    },
  ];

  if (dietSelection === 'Inne') {
    fields.splice(1, 0, {
      type: 'text',
      label: '',
      name: 'accommodationPreferences.dietOther',
    });
  }

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          flexWrap: 'wrap',
          gap: 4,
        }}
      >
        {fields.map((field) => (
          <Box key={field.name} sx={fieldSx(field, mobileScreen)}>
            <QuestionLabel
              component='label'
              sx={{ mb: 1, color: 'rgba(255,255,255,0.8)' }}
              collapsible={!(field.alternateLabel || mobileScreen)}
            >
              {field.label}
            </QuestionLabel>
            <FormField
              {...field}
              label={null}
              ariaLabel={
                typeof field.label === 'string' ? field.label : undefined
              }
              register={register}
              error={
                errors?.accommodationPreferences?.[field.name.split('.')[1]]
              }
              helperText={
                errors?.accommodationPreferences?.[field.name.split('.')[1]]
                  ?.message
              }
              fullWidth
            />
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
